import { useWatch } from 'react-hook-form';
import { CurrencyInputFieldProps } from '@mews-commander/form';
import { CurrencyInputFieldWrapper } from '../../../CurrencyInputFieldWrapper';
import { CashierTransactionFormValues } from './formMapping';

export const CurrencyInputField = (props: CurrencyInputFieldProps) => {
    const currencyCode = useWatch<CashierTransactionFormValues>({
        name: 'currency',
    });

    return <CurrencyInputFieldWrapper {...props} currencyCode={currencyCode} />;
};
